import { typedObjectKeys } from "~/app/utils/typeUtils"
import { TodoTasksTaskCategory } from "@oysterhr/schema"
import { TodoTasksTaskDetailsFragment } from "../../gql/graphql"
export const SortedCategoriesEnum = {
  [TodoTasksTaskCategory.CompanyAdminTask]: TodoTasksTaskCategory.CompanyAdminTask,
  [TodoTasksTaskCategory.TeamMemberTask]: TodoTasksTaskCategory.TeamMemberTask,
  [TodoTasksTaskCategory.AgreementTask]: TodoTasksTaskCategory.AgreementTask,
  [TodoTasksTaskCategory.AdditionalTask]: TodoTasksTaskCategory.AdditionalTask,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T
}

export const groupTasksByCategory = (tasks: TodoTasksTaskDetailsFragment[]) => {
  const categories: PartialRecord<TodoTasksTaskCategory, TodoTasksTaskDetailsFragment[]> = {
    [TodoTasksTaskCategory.CompanyAdminTask]: [],
    [TodoTasksTaskCategory.PrepaidTask]: [],
    [TodoTasksTaskCategory.OysterSafeTask]: [],
    [TodoTasksTaskCategory.TeamMemberTask]: [],
    [TodoTasksTaskCategory.AgreementTask]: [],
    [TodoTasksTaskCategory.AdditionalTask]: [],
    [TodoTasksTaskCategory.Settings]: [],
  }

  tasks.forEach(task => {
    categories[task.category]?.push(task)
  })

  // Remove empty categories
  typedObjectKeys(categories).forEach(category => {
    if (categories[category]?.length === 0) {
      // Safe to delete because we've checked for its presence above
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete categories[category]
    }
  })

  return categories
}
